var map = {
	"./AccountPage.js": 4062,
	"./ChangePasswordPage.js": 8657,
	"./ForgotPasswordPage.js": 7262,
	"./HomeRedirect.js": 9387,
	"./LandingPage.js": 8393,
	"./LandingsPage.js": 1835,
	"./LoginPage.js": 7308,
	"./LogoutPage.js": 4325,
	"./NewPhrasePage.js": 3434,
	"./NewProjectPage.js": 5879,
	"./NotFoundPage.js": 699,
	"./PhrasePage.js": 4169,
	"./PhrasesPage.js": 7181,
	"./ProjectPage.js": 8011,
	"./ProjectsPage.js": 4753,
	"./SetupProjectPage.js": 2453,
	"./SignupPage.js": 7156,
	"./TeamMemberPage.js": 2350,
	"./TeamPage.js": 2456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5031;